import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    marginBottom: 32,
    height: 475,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: 'auto',
      padding: 16
    }
  },
  selectBoxes: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  boxContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 40,
    gap: 12,
    marginBottom: 12,
    marginRight: 60,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginLeft: 0,
      marginRight: 0,
      gap: 8
    }
  },
  searchBoxContainerRow: {
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      marginTop: 10
    }
  },
  guestNameSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 2fr',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  datePickersContainer: {
    backgroundColor: 'transparent',
    marginRight: 57,
    marginTop: -320,
    width: 282,
    height: 50,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    top: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: 0,
      height: 'auto',
      marginRight: 0
    }
  },
  ButtonsContainer: {
    marginTop: 25,
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      gap: 8
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  applyButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[200]}`,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  resetButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[700]}`,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
